import { render, staticRenderFns } from "./FlockFcr.vue?vue&type=template&id=3c4b9fcf&scoped=true&"
import script from "./FlockFcr.vue?vue&type=script&lang=js&"
export * from "./FlockFcr.vue?vue&type=script&lang=js&"
import style0 from "./FlockFcr.vue?vue&type=style&index=0&id=3c4b9fcf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4b9fcf",
  null
  
)

export default component.exports